// import React, { useEffect, useState, useRef } from "react";
// import closeButon from "../../../../assests/images/close-o.png";

// function SelectBroadbandPackage({
//   packageInfo,
//   setPackageInfo,
//   setIsOpenBb,
//   data,
//   setSelectedBBObj,
// }) {
//   //   const [bbType, setBbType] = useState("S");
//   const [bbType, setBbType] = useState("A");
//   const [open, setOpen] = useState(false);
//   const ref = useRef(null);

//   useEffect(() => {
//     setTimeout(() => {
//       setOpen(true);
//       document.addEventListener("mousedown", handleClickOutside);
//     }, 0);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [open]);

//   const handleClickOutside = (event) => {
//     if (ref.current && !ref.current.contains(event.target)) {
//       setIsOpenBb(false);
//     }
//   };

//   const handleClosePopup = () => {
//     setIsOpenBb(false);
//   };

//   const selectArray = () => {
//     if (data) {
//       //   if (bbType === "S") {
//       //     return data.Standard[0];
//       //   } else
//       if (bbType === "A") {
//         return data.Any[0];
//       } else if (bbType === "U") {
//         return [...data.Unlimited[0], ...data.Flash[0]];
//       } else {
//         return [];
//       }
//     } else {
//       return [];
//     }
//   };

//   return (
//     <div className="packageSelect" ref={ref}>
//       {open && (
//         <div className={open ? "broadbandPack show" : "broadbandPack"}>
//           <img
//             src={closeButon}
//             alt="Close"
//             className="close-icon"
//             style={{
//               position: "absolute",
//               maxHeight: "20px",
//               top: "10px",
//               right: "10px",
//               cursor: "pointer",
//               textAlign: "right",
//             }}
//             onClick={handleClosePopup}
//           />
//           <div className="topButtons">
//             {/* <button onClick={() => setBbType('S')} className={bbType === 'S' ? 'blue' : null}>
//                             Value Packages
//                         </button> */}
//             <button
//               onClick={() => setBbType("A")}
//               className={bbType === "A" ? "blue" : null}
//             >
//               Any Time Packages
//             </button>
//             <button
//               onClick={() => setBbType("U")}
//               className={bbType === "U" ? "blue" : null}
//             >
//               Unlimited Packages
//             </button>
//           </div>
//           <div className="bbPackages">
//             {selectArray().map((obj, index) => {
//               return (
//                 <div className="package-item-wrapper" key={index}>
//                   <div
//                     className={
//                       packageInfo.bbPackages === obj.BB_PACKAGE_NAME
//                         ? "package-item selected"
//                         : "package-item"
//                     }
//                     onClick={() => {
//                       setPackageInfo({
//                         ...packageInfo,
//                         bbPackages: obj.BB_PACKAGE_NAME,
//                         bbPackagesData: obj,
//                         bbType: bbType,
//                       });
//                       setSelectedBBObj(obj);
//                       setTimeout(() => {
//                         setIsOpenBb(false);
//                       }, 150);
//                     }}
//                   >
//                     <div className="packageName">{obj.BB_PACKAGE_NAME}</div>
//                     {bbType === "U" ? (
//                       <div className="amountDetails">
//                         <div className="package-box any">
//                           <div className="package-type">Unlimited Data</div>
//                         </div>
//                       </div>
//                     ) : bbType === "A" ? (
//                       <div className="amountDetails">
//                         <div className="package-box any">
//                           <div className="package-type">
//                             {obj.STANDARD_GB}GB
//                           </div>
//                         </div>
//                       </div>
//                     ) : (
//                       <div className="amountDetails">
//                         <div className="package-box standard">
//                           <div className="package-type">Standard</div>
//                           <div className="package-amount">
//                             {obj.STANDARD_GB}GB
//                           </div>
//                         </div>
//                         <div className="plus"></div>
//                         <div className="package-box free">
//                           <div className="package-type">Free</div>
//                           <div className="package-amount">{obj.FREE_GB}GB</div>
//                         </div>
//                       </div>
//                     )}
//                     <div className="priceDetails">
//                       <div className="price">
//                         {obj.MONTHLY_RENTAL} LKR + Tax
//                       </div>
//                       <div className="per-month">(Per Month)</div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default SelectBroadbandPackage;


import React, { useEffect, useState, useRef } from "react";
import closeButon from "../../../../assests/images/close-o.png";
import { getPackageSpeed } from "./packageSpeedMapping";

function SelectBroadbandPackage({
  packageInfo,
  setPackageInfo,
  setIsOpenBb,
  data,
  setSelectedBBObj,
  setSelectedVioceObj,
  setSelectedPeoObj,
}) {
  // Category mapping: API key -> Display name
  const categoryMap = {
    A: "Any Time Packages",
    U: "Unlimited Packages",
    Trio: "Trio Packages",
    Ultra: "Ultra Packages",
    S: "Value Packages", // if needed in future
  };

  // Get available categories from API data
  const getAvailableCategories = () => {
    if (!data) return [];
    
    const available = [];
    
    // Check for each category in the data
   
    if (data.Unlimited && data.Unlimited[0] && data.Unlimited[0].length > 0) {
      available.push({ key: "U", name: categoryMap.U });
    }
    if (data.Trio && data.Trio[0] && data.Trio[0].length > 0) {
      available.push({ key: "Trio", name: categoryMap.Trio });
    }
    if (data.Ultra && data.Ultra[0] && data.Ultra[0].length > 0) {
      available.push({ key: "Ultra", name: categoryMap.Ultra });
    }
    if (data.Any && data.Any[0] && data.Any[0].length > 0) {
      available.push({ key: "A", name: categoryMap.A });
    }
    if (data.Standard && data.Standard[0] && data.Standard[0].length > 0) {
      available.push({ key: "S", name: categoryMap.S });
    }
    
    return available;
  };

  const availableCategories = getAvailableCategories();
  
  // Set initial bbType to first available category
  const [bbType, setBbType] = useState(
    availableCategories.length > 0 ? availableCategories[0].key : "A"
  );
  
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Update bbType when data changes
  useEffect(() => {
    if (availableCategories.length > 0) {
      const firstCategory = availableCategories[0].key;
      if (!availableCategories.find(cat => cat.key === bbType)) {
        setBbType(firstCategory);
      }
    }
  }, [data]);

  useEffect(() => {
    setTimeout(() => {
      setOpen(true);
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpenBb(false);
    }
  };

  const handleClosePopup = () => {
    setIsOpenBb(false);
  };

  const selectArray = () => {
    if (!data) return [];

    // Handle Unlimited category (combines Unlimited and Flash)
    if (bbType === "U") {
      const unlimited = data.Unlimited?.[0] || [];
      const flash = data.Flash?.[0] || [];
      return [...unlimited, ...flash];
    }
    
    // Handle Any Time Packages
    if (bbType === "A") {
      return data.Any?.[0] || [];
    }
    
    // Handle Trio category
    if (bbType === "Trio") {
      return data.Trio?.[0] || [];
    }
    
    // Handle Ultra category
    if (bbType === "Ultra") {
      return data.Ultra?.[0] || [];
    }
    
    // Handle Standard/Value Packages (if needed)
    if (bbType === "S") {
      return data.Standard?.[0] || [];
    }
    
    return [];
  };

  // Get display label for current category
  const getCategoryLabel = (categoryKey) => {
    return categoryMap[categoryKey] || categoryKey;
  };

  // Determine if package should show "Unlimited Data" badge
  const isUnlimitedCategory = (categoryKey) => {
    return categoryKey === "U";
  };

  return (
    <div className="packageSelect" ref={ref}>
      {open && (
        <div className={open ? "broadbandPack show" : "broadbandPack"}>
          <img
            src={closeButon}
            alt="Close"
            className="close-icon"
            style={{
              position: "absolute",
              maxHeight: "20px",
              top: "10px",
              right: "10px",
              cursor: "pointer",
              textAlign: "right",
            }}
            onClick={handleClosePopup}
          />
          <div className="topButtons">
            {availableCategories.map((category) => (
              <button
                key={category.key}
                onClick={() => setBbType(category.key)}
                className={bbType === category.key ? "blue" : null}
              >
                {category.name}
              </button>
            ))}
          </div>
          <div className="bbPackages">
            {selectArray().map((obj, index) => {
              return (
                <div className="package-item-wrapper" key={index}>
                  <div
                    className={
                      packageInfo.bbPackages === obj.BB_PACKAGE_NAME
                        ? "package-item selected"
                        : "package-item"
                    }
                    onClick={() => {
                      setPackageInfo({
                        ...packageInfo,
                        bbPackages: obj.BB_PACKAGE_NAME,
                        bbPackagesData: obj,
                        bbType: bbType,
                        voicePackages: "",
                        voicePackagesData: {},
                        peoTvPackages: "",
                        peoPackagesData: {},
                      });
                      setSelectedBBObj(obj);
                      setSelectedVioceObj?.({});
                      setSelectedPeoObj?.({});
                      setTimeout(() => {
                        setIsOpenBb(false);
                      }, 150);
                    }}
                  >
                    <div className="packageName">{obj.BB_PACKAGE_NAME}</div>
                    {isUnlimitedCategory(bbType) ? (
                      <div className="amountDetails unlimited-packages">
                        <div className="package-box any">
                          <div className="package-type">Unlimited Internet</div>
                          <div className="package-speed">{getPackageSpeed(obj.BB_PACKAGE_NAME)}</div>
                        </div>
                        <div className="package-box any">
                          <div className="package-type">Unlimited Voice</div>
                        </div>
                      </div>
                    ) : bbType === "Ultra" ? (
                      <div className="amountDetails unlimited-packages">
                        <div className="package-box any">
                          <div className="package-type">
                            {obj.STANDARD_GB}GB
                          </div>
                          <div className="package-speed">{getPackageSpeed(obj.BB_PACKAGE_NAME)}</div>
                        </div>
                        <div className="package-box any">
                          <div className="package-type">Unlimited Voice</div>
                        </div>
                      </div>
                    ) : bbType === "Trio" ? (
                      <div className="amountDetails unlimited-packages">
                        <div className="package-box any">
                          <div className="package-type">
                            {obj.STANDARD_GB}GB
                          </div>
                          <div className="package-speed">{getPackageSpeed(obj.BB_PACKAGE_NAME)}</div>
                        </div>
                        <div className="package-box any">
                          <div className="package-type">Unlimited Voice</div>
                          <div className="package-type">Free Peo TV</div>
                        </div>
                      </div>
                    ) : bbType === "A" ? (
                      <div className="amountDetails unlimited-packages">
                        <div className="package-box any">
                          <div className="package-type">
                            {obj.STANDARD_GB}GB
                          </div>
                          <div className="package-speed">{getPackageSpeed(obj.BB_PACKAGE_NAME)}</div>
                        </div>
                      </div>
                    ) : (
                      <div className="amountDetails">
                        <div className="package-box standard">
                          <div className="package-type">Standard</div>
                          <div className="package-amount">
                            {obj.STANDARD_GB}GB
                          </div>
                        </div>
                        <div className="plus"></div>
                        <div className="package-box free">
                          <div className="package-type">Free</div>
                          <div className="package-amount">{obj.FREE_GB}GB</div>
                        </div>
                      </div>
                    )}
                    <div className="priceDetails">
                      <div className="price">
                        {obj.MONTHLY_RENTAL} LKR + Tax
                      </div>
                      <div className="per-month">(Per Month)</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default SelectBroadbandPackage;